import { PreviewProvider } from './previewProvider';
import { InstallerProvider } from './installerProvider';
import { ReactNode } from 'react';
declare global {
	interface Window {
		__connectPreview: boolean;
	}
}
export function MainProvider({ children }: { children: ReactNode }) {
	const Provider = window.__connectPreview ? PreviewProvider : InstallerProvider;
	return (
		<Provider>
			{children}
		</Provider>
	)
}
